import { ROOT_ROUTE } from 'constants.app'

export enum Pages {
  HOME = 'home',
  CUG_HOME = 'rcbp-cug-home',
  LANDING = 'landing',
  PLAN_SELECTION = 'plan-selection',
  EDIT_CONNECTION = 'edit-connection-details',
  BILLER_SELECTION = 'biller-selection',
  CHECKOUT = 'checkout',
  ERROR = 'error',
  CONTACTS = 'contacts',
  PAYMENT_SUCCESS = 'payment-success',
  PAYMENT_FAILURE = 'payment-failed',
  RECHARGES_HOME = 'recharges-home',
  CONSUMER_IDENTIFICATION = 'consumer-identification',
  ALL_BILLS_RECHARGES = 'bills-and-recharges',
  BILLS = 'bills',
  BILL_DETAILS = 'bill-details',
}

export const getPageURL = (page: Pages): string => {
  return `${ROOT_ROUTE}/${page}`
}

const pagesThatOpenInBottomsheet = [Pages.CHECKOUT]
export const getTopSafeAreaForCustomToolBar = (pathname: string): boolean => {
  return !pagesThatOpenInBottomsheet.includes(pathname.split('/')[4] as Pages)
}
